import { Service } from "./service";

export class BonCommandeService {
	readonly id: number;
	service: Service;
	pourcentageCharge: number;

	constructor(
		options: {
			service?: Service;
			pourcentageCharge?: number;
		} = {}
	) {
		this.service = options.service || null;
		this.pourcentageCharge = options.pourcentageCharge || null;
	}
}
